var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ConstantValues } from 'src/app/bpg-common/models/bpg-constants';
import { EnvironmentConfiguration } from 'src/app/environment/services/environment.configuration';
import { BpgEventsService } from 'src/app/bpg-events/bpg-events.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { BpgExpensesService } from '../bpg-expenses.service';
import { NgSelectComponent } from '@ng-select/ng-select';
import { BpgCommonService } from 'src/app/bpg-common/services/bpg-common.service';
import { buildFiscalYearOptions } from 'src/app/omnidashboard/core/omnidashboard-fiscal-year';
var ActualsComponent = /** @class */ (function () {
    function ActualsComponent(spinner, router, bpgEventsService, bpgExpenseService, environment, bpgCommonService) {
        this.spinner = spinner;
        this.router = router;
        this.bpgEventsService = bpgEventsService;
        this.bpgExpenseService = bpgExpenseService;
        this.environment = environment;
        this.bpgCommonService = bpgCommonService;
        this.actualsDataList = [];
        this.limit = ConstantValues.pageLimit;
        this.currentShowingElements = ConstantValues.pageLimit;
        this.currentPage = 1;
        this.isConsolidatedSelected = true;
        this.isDetailedBreakdownSelected = false;
        this.quarter = '';
        this.currentFy = buildFiscalYearOptions().selectedFiscalYear;
        this.priorFy = String(+this.currentFy - 1);
        this.fiscalYear = this.priorFy;
        this.fyLabels = [this.priorFy.slice(-2), this.currentFy.slice(-2)];
        this.fyValues = [this.priorFy, this.currentFy];
        this.type = 'DASHBOARD';
        this.chapterCombination = '';
        this.selectedErgId = '0';
        this.total = { fiscalQtr: '', chapterApprovedAmount: 0, budget: 0, spent: 0, ergDiscrepancy: 0, plannedVsActual: 0 };
        this.selectAllConstant = 'Select All';
        this.loginData = JSON.parse(localStorage.getItem('loginData'));
        this.adminId = localStorage.getItem('adminId');
        this.lastUpdatedDate = 'July 07, 2026';
        this.printFlag = 'ByChapter';
    }
    ActualsComponent.prototype.ngOnInit = function () {
        this.spinner.show();
        this.logUserAction();
        if (this.environment.envName === 'dev' || this.environment.envName === 'qa' || this.environment.envName === 'prod') {
            if (localStorage.getItem('loginData') === null || localStorage.getItem('loginData') === undefined) {
                this.router.navigate(['/log-out']);
            }
        }
        if (localStorage.getItem('logOutFlag') === "true") {
            this.router.navigate(['/log-out']);
        }
        this.isMultiChapterAdmin = localStorage.getItem('isMultiChapterAdmin') === 'true';
        this.init();
    };
    ActualsComponent.prototype.init = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.myChapters()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.getActualsChapters()];
                    case 2:
                        _a.sent();
                        this.getActualsErg();
                        this.getActualsSite();
                        this.isErgSelected = false;
                        this.isSiteSelected = false;
                        this.isChapterSelected = true;
                        this.spinner.show();
                        this.consolidated();
                        return [2 /*return*/];
                }
            });
        });
    };
    ActualsComponent.prototype.pageChanged = function (event) {
        this.landingData.page = event - 1;
        this.currentPage = event;
        if ((this.currentPage * this.limit) < this.numberOfElements) {
            this.currentShowingElements = this.currentPage * this.limit;
        }
        else if ((this.currentPage * this.limit) > this.numberOfElements) {
            this.currentShowingElements = this.numberOfElements;
        }
        this.getActualDataList();
    };
    ActualsComponent.prototype.getActualDataList = function () {
        return __awaiter(this, void 0, void 0, function () {
            var chapterIdForPayload;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this.chapterList) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.getActualsChapters()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        if (this.selectedChapterId == null) {
                            this.selectedChapterId = this.myChapterIds;
                        }
                        if (this.isConsolidatedSelected) {
                            chapterIdForPayload = this.selectedChapterId;
                            if (Array.isArray(chapterIdForPayload)) {
                                this.selectedChapterId = chapterIdForPayload.join(',');
                            }
                            if (this.isErgSelected) {
                                this.landingData = {
                                    "filter": {
                                        "QUARTER": this.quarter,
                                        "FY": this.fiscalYear,
                                        "flag": this.type,
                                        "chapterFilterFlag": "bpg",
                                        "bpgId": this.selectedErgId
                                    },
                                    "moduleId": 0,
                                    "page": this.currentPage - 1,
                                    "presentRole": "",
                                    "searchTerm": "",
                                    "size": this.limit,
                                    "uid": "",
                                    "sortProperty": "chapter_id",
                                    "sortDirection": "ASC"
                                };
                            }
                            else if (this.isSiteSelected) {
                                this.landingData = {
                                    "filter": {
                                        "QUARTER": this.quarter,
                                        "FY": this.fiscalYear,
                                        "flag": this.type,
                                        "chapterFilterFlag": "site",
                                        "siteId": this.selectedSiteId
                                    },
                                    "moduleId": 0,
                                    "page": this.currentPage - 1,
                                    "presentRole": "",
                                    "searchTerm": "",
                                    "size": this.limit,
                                    "uid": "",
                                    "sortProperty": "chapter_id",
                                    "sortDirection": "ASC"
                                };
                            }
                            else {
                                if (this.isMultiChapterAdmin && (this.adminId !== '1')) {
                                    this.landingData = {
                                        "filter": {
                                            "QUARTER": this.quarter,
                                            "FY": this.fiscalYear,
                                            "flag": this.type,
                                            "chapterFilterFlag": "chapter",
                                            "chapterId": this.selectedChapterId,
                                            "multiChapterAdmin": "true"
                                        },
                                        "moduleId": 0,
                                        "page": this.currentPage - 1,
                                        "presentRole": "",
                                        "searchTerm": "",
                                        "size": this.limit,
                                        "uid": "",
                                        "sortProperty": "chapter_id",
                                        "sortDirection": "ASC"
                                    };
                                }
                                else {
                                    this.landingData = {
                                        "filter": {
                                            "QUARTER": this.quarter,
                                            "FY": this.fiscalYear,
                                            "flag": this.type,
                                            "chapterFilterFlag": "chapter",
                                            "chapterId": this.selectedChapterId,
                                        },
                                        "moduleId": 0,
                                        "page": this.currentPage - 1,
                                        "presentRole": "",
                                        "searchTerm": "",
                                        "size": this.limit,
                                        "uid": "",
                                        "sortProperty": "chapter_id",
                                        "sortDirection": "ASC"
                                    };
                                }
                            }
                        }
                        else {
                            this.landingData = {
                                "filter": {
                                    "QUARTER": this.quarter,
                                    "FY": this.fiscalYear,
                                    "flag": this.type,
                                    "chapterCombination": this.chapterCombination
                                },
                                "moduleId": 0,
                                "page": this.currentPage - 1,
                                "presentRole": "",
                                "searchTerm": "",
                                "size": this.limit,
                                "uid": ""
                            };
                        }
                        this.bpgEventsService.getBudgetActualsData(this.landingData).subscribe(function (data) {
                            _this.timeOutError = false;
                            if (_this.chapterList.length === 0) {
                                _this.actualsDataList = [];
                                _this.numberOfElements = 0;
                            }
                            else {
                                _this.actualsDataList = data.content;
                                _this.numberOfElements = data.totalElements;
                            }
                            if (_this.actualsDataList.length === 0) {
                                _this.tableShow = false;
                                _this.noDataFound = true;
                            }
                            else {
                                _this.tableShow = true;
                                _this.noDataFound = false;
                                _this.totalReset();
                                for (var _i = 0, _a = _this.actualsDataList; _i < _a.length; _i++) {
                                    var data_1 = _a[_i];
                                    data_1.plannedVsActual = (data_1.chapterApprovedAmount - data_1.spent);
                                    data_1.printPvsA = data_1.plannedVsActual;
                                    if (_this.isErgSelected || _this.isSiteSelected) {
                                        _this.total.ergDiscrepancy = _this.total.ergDiscrepancy + data_1.difference;
                                        _this.total.chapterApprovedAmount = _this.total.chapterApprovedAmount + data_1.chapterApprovedAmount;
                                        _this.total.budget = _this.total.budget + data_1.budget;
                                        _this.total.spent = _this.total.spent + data_1.spent;
                                        _this.total.plannedVsActual = _this.total.plannedVsActual + data_1.plannedVsActual;
                                    }
                                    if (data_1.difference < 0) {
                                        data_1.symbolRed = true;
                                        data_1.symbolGreen = false;
                                        data_1.ergDiscrepancy = (-1) * data_1.difference;
                                    }
                                    else {
                                        data_1.symbolGreen = true;
                                        data_1.symbolRed = false;
                                        data_1.ergDiscrepancy = data_1.difference;
                                    }
                                    if (data_1.plannedVsActual < 0) {
                                        data_1.symbolRed1 = true;
                                        data_1.symbolGreen1 = false;
                                        data_1.plannedVsActual = (-1) * data_1.plannedVsActual;
                                    }
                                    else {
                                        data_1.symbolGreen1 = true;
                                        data_1.symbolRed1 = false;
                                    }
                                    data_1.fiscalQtr = "FY" + data_1.fiscalYear.slice(-2) + ((_this.quarter !== '') ? (' - ' + _this.quarter) : '');
                                }
                                if (_this.isErgSelected || _this.isSiteSelected) {
                                    _this.total.fiscalQtr = "FY" + _this.fiscalYear.slice(-2) + ((_this.quarter !== '') ? (' - ' + _this.quarter) : '');
                                }
                            }
                            _this.spinner.hide();
                        }, function (err) {
                            _this.spinner.hide();
                            if (err.value.statusText === ConstantValues.unknownError) {
                                _this.timeOutError = true;
                            }
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    ActualsComponent.prototype.getActualsChapters = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(this.myChapterIds === undefined)) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this.myChapters().then()];
                    case 1:
                        _a.myChapterIds = _b.sent();
                        _b.label = 2;
                    case 2: return [2 /*return*/, new Promise(function (resolve) {
                            _this.bpgExpenseService.getActualsChapterList().subscribe(function (data) {
                                for (var _i = 0, data_2 = data; _i < data_2.length; _i++) {
                                    var d = data_2[_i];
                                    d.modChapterName = d.chapterName.replace(/-/g, ' ').replace(/\s+/g, ' ').trim().toUpperCase();
                                }
                                if (_this.adminId === '1' || _this.adminId === 1) {
                                    _this.chapterList = data;
                                    // this.chapterList.unshift({ chapterId: this.myChapterIds, modChapterName: this.selectAllConstant.toUpperCase() });
                                }
                                else {
                                    _this.chapterList = data.filter(function (chapters) { return _this.myChapterIds.includes(chapters.chapterId); });
                                    _this.myChapterNames = _this.chapterList.map(function (chapter) { return chapter.chapterName; }).join(', ');
                                }
                                _this.myChapterIds = '';
                                for (var _a = 0, _b = _this.chapterList; _a < _b.length; _a++) {
                                    var c = _b[_a];
                                    if (_this.myChapterIds === '') {
                                        _this.myChapterIds = _this.myChapterIds + c.chapterId;
                                    }
                                    else {
                                        _this.myChapterIds = _this.myChapterIds + "," + c.chapterId;
                                    }
                                }
                                _this.selectedChapterId = _this.myChapterIds;
                                _this.chapterCombination = _this.myChapterNames;
                                resolve(_this.chapterList);
                            }, function (err) {
                                _this.spinner.hide();
                                if (err.value.statusText === ConstantValues.unknownError) {
                                    _this.timeOutError = true;
                                }
                            });
                        })];
                }
            });
        });
    };
    ActualsComponent.prototype.getActualsErg = function () {
        var _this = this;
        this.bpgExpenseService.getActualsBPGList().subscribe(function (data) {
            _this.ergList = data;
            _this.ergList.unshift({ bpgId: 0, bpgName: _this.selectAllConstant.toUpperCase() });
        }, function (err) {
            _this.spinner.hide();
            if (err.value.statusText === ConstantValues.unknownError) {
                _this.timeOutError = true;
            }
        });
    };
    ActualsComponent.prototype.getActualsSite = function () {
        var _this = this;
        this.bpgExpenseService.getActualsSiteList().subscribe(function (data) {
            _this.siteList = data;
            _this.siteList.unshift({ siteId: 0, siteName: _this.selectAllConstant.toUpperCase() });
        }, function (err) {
            _this.spinner.hide();
            if (err.value.statusText === ConstantValues.unknownError) {
                _this.timeOutError = true;
            }
        });
    };
    ActualsComponent.prototype.consolidated = function () {
        this.resetFilter();
        this.currentPage = 1;
        this.currentShowingElements = 10; // showing elements (out of) fixed
        this.isConsolidatedSelected = true;
        this.isDetailedBreakdownSelected = false;
        this.type = 'DASHBOARD';
        this.quarter = '';
        this.fiscalYear = '2026';
        if (this.adminId === '1') {
            if (!this.isSiteSelected && this.isErgSelected && !this.isChapterSelected) {
                this.selectedErgId = '0';
                this.currentShowingElements = 100;
                this.limit = 100;
            }
            else if (this.isSiteSelected && !this.isErgSelected && !this.isChapterSelected) {
                this.selectedSiteId = 0;
                this.currentShowingElements = 100;
                this.limit = 100;
            }
            else {
                this.selectedChapterId = this.myChapterIds;
            }
        }
        else {
            this.selectedChapterId = this.myChapterIds;
        }
        this.getActualDataList();
    };
    ActualsComponent.prototype.detailedBreakdown = function () {
        this.resetFilter();
        this.dropdown.clearModel();
        this.isChapterSelected = true;
        this.isErgSelected = false;
        this.isSiteSelected = false;
        this.currentPage = 1;
        this.limit = 10;
        this.currentShowingElements = 10;
        this.printFlag = 'ByChapter';
        this.isConsolidatedSelected = false;
        this.isDetailedBreakdownSelected = true;
        this.isErgSelected = false;
        this.type = 'DETAILEDBREAKDOWN';
        this.quarter = '';
        this.fiscalYear = '2026';
        if (this.adminId === '1') {
            this.chapterCombination = '';
        }
        else {
            this.chapterCombination = this.myChapterNames;
        }
        this.getActualDataList();
    };
    ActualsComponent.prototype.chapterChange = function (event) {
        if (event) {
            this.currentPage = 1;
            this.limit = 10;
            this.currentShowingElements = 10;
            this.selectedChapterId = null;
            this.selectedChapterId = event.chapterId;
            this.quarter = '';
            this.chapterCombination = event.chapterName;
            if (this.chapterCombination === this.selectAllConstant) {
                this.chapterCombination = '';
            }
            this.getActualDataList();
        }
    };
    ActualsComponent.prototype.quarterSelected = function (quarter) {
        if (quarter === this.quarter) {
            this.quarter = ''; // for toggle
        }
        else {
            this.quarter = quarter;
        }
        this.getActualDataList();
    };
    ActualsComponent.prototype.selectedFY = function (fiscalYear) {
        this.fiscalYear = fiscalYear; //hard coded for fiscal year
        this.quarter = '';
        this.selectedChapterId = this.myChapterIds;
        this.selectedErgId = '0';
        this.selectedSiteId = '0';
        this.chapterCombination = this.myChapterNames;
        this.dropdown.clearModel();
        this.getActualDataList();
    };
    ActualsComponent.prototype.ergChange = function (event) {
        if (event) {
            this.selectedErgId = null;
            this.selectedErgId = event.bpgId;
            this.quarter = '';
            this.limit = 100;
            this.currentShowingElements = 100;
            this.totalReset();
            this.getActualDataList();
        }
    };
    ActualsComponent.prototype.siteChange = function (event) {
        this.selectedSiteId = null;
        this.selectedSiteId = event.siteId;
        this.quarter = '';
        this.limit = 100;
        this.currentShowingElements = 100;
        this.totalReset();
        this.getActualDataList();
    };
    ActualsComponent.prototype.totalReset = function () {
        this.total.ergDiscrepancy = 0;
        this.total.chapterApprovedAmount = 0;
        this.total.budget = 0;
        this.total.spent = 0;
        this.total.plannedVsActual = 0;
        this.total.fiscalQtr = 'FY' + this.fiscalYear.slice(-2);
    };
    ActualsComponent.prototype.resetFilter = function () {
        this.type = '';
        this.quarter = '';
        this.fiscalYear = '';
        this.chapterCombination = '';
        this.selectedChapterId = '';
        this.selectedErgId = '';
        this.selectedSiteId = '';
        this.limit = 10;
        this.currentShowingElements = 10;
    };
    ActualsComponent.prototype.radioErgSelected = function () {
        this.isErgSelected = true;
        this.isChapterSelected = false;
        this.isSiteSelected = false;
        this.limit = 100;
        this.currentShowingElements = 100;
        this.printFlag = 'ByAffinity';
        this.dropdown.clearModel();
        this.consolidated();
    };
    ActualsComponent.prototype.radioChapterSelected = function () {
        this.isErgSelected = false;
        this.isChapterSelected = true;
        this.isSiteSelected = false;
        this.printFlag = 'ByChapter';
        this.dropdown.clearModel();
        this.consolidated();
    };
    ActualsComponent.prototype.radioSiteSelected = function () {
        this.isErgSelected = false;
        this.isChapterSelected = false;
        this.isSiteSelected = true;
        this.printFlag = 'BySite';
        this.dropdown.clearModel();
        this.consolidated();
    };
    ActualsComponent.prototype.myChapters = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                this.userAndRoleIdDTO = {
                    userId: this.loginData['userId'],
                    roleId: localStorage.getItem('adminId')
                };
                return [2 /*return*/, new Promise(function (resolve) {
                        _this.bpgEventsService.getChapterDropDown(_this.userAndRoleIdDTO).subscribe(function (data) {
                            _this.myChapterIds = data.map(function (item) { return item.chapterId; });
                            resolve(_this.myChapterIds);
                        }, function (err) {
                            _this.spinner.hide();
                            if (err.value.statusText === ConstantValues.unknownError) {
                                _this.timeOutError = true;
                            }
                        });
                    })];
            });
        });
    };
    ActualsComponent.prototype.downloadActualsListAsExcel = function () {
        var _this = this;
        var exportData;
        var fileName = '';
        if (this.isConsolidatedSelected) {
            if (this.isChapterSelected) {
                var filteredData = this.actualsDataList.map(function (_a) {
                    var chapterCombination = _a.chapterCombination, fiscalQtr = _a.fiscalQtr, chapterApprovedAmount = _a.chapterApprovedAmount, budget = _a.budget, spent = _a.spent, printPvsA = _a.printPvsA;
                    return (__assign({ Chapter: chapterCombination, FiscalYear: fiscalQtr, AnnualPlanApproved: chapterApprovedAmount, BudgetApprovedInERGConnect: budget, SAPActual: spent }, (_this.quarter === '' && { Available: printPvsA })));
                });
                exportData = filteredData;
            }
            else if (this.isErgSelected) {
                var filteredData = this.actualsDataList.map(function (_a) {
                    var chapterCombination = _a.chapterCombination, fiscalQtr = _a.fiscalQtr, chapterApprovedAmount = _a.chapterApprovedAmount, budget = _a.budget, spent = _a.spent, difference = _a.difference, printPvsA = _a.printPvsA;
                    return (__assign({ ERG: chapterCombination, FiscalYear: fiscalQtr, AnnualPlanApproved: chapterApprovedAmount, BudgetApprovedInERGConnect: budget, SAPActual: spent }, (_this.adminId === '1' && { ERGDiscrepancy: difference }), (_this.quarter === '' && { Available: printPvsA })));
                });
                exportData = filteredData;
            }
            else if (this.isSiteSelected) {
                var filteredData = this.actualsDataList.map(function (_a) {
                    var chapterCombination = _a.chapterCombination, fiscalQtr = _a.fiscalQtr, chapterApprovedAmount = _a.chapterApprovedAmount, budget = _a.budget, spent = _a.spent, printPvsA = _a.printPvsA;
                    return (__assign({ Site: chapterCombination, FiscalYear: fiscalQtr, AnnualPlanApproved: chapterApprovedAmount, BudgetApprovedInERGConnect: budget, SAPActual: spent }, (_this.quarter === '' && { Available: printPvsA })));
                });
                exportData = filteredData;
            }
            fileName = "Actuals_Dashboard_" + this.printFlag + "_FY" + this.fiscalYear + this.quarter;
        }
        else if (this.isDetailedBreakdownSelected) {
            var filteredData = this.actualsDataList.map(function (_a) {
                var projectLevel03 = _a.projectLevel03, projectLevel07 = _a.projectLevel07, fiscalQtr = _a.fiscalQtr, date = _a.date, amount = _a.amount;
                return ({
                    Chapter: projectLevel03,
                    WBSCode: projectLevel07,
                    FiscalYear: fiscalQtr,
                    Date: date,
                    Amount: amount
                });
            });
            exportData = filteredData;
            fileName = "Actuals_DetailedBreakdown_FY" + this.fiscalYear + this.quarter;
        }
        this.bpgEventsService.exportAsExcelFile(exportData, fileName);
    };
    ActualsComponent.prototype.logUserAction = function () {
        var loginData = JSON.parse(localStorage.getItem("loginData"));
        var userId = loginData["userId"];
        var data = {
            userId: userId,
            categoryDescription: "Budget - Actuals",
        };
        this.bpgCommonService.logUserAction(data).subscribe(function (_data) { });
    };
    return ActualsComponent;
}());
export { ActualsComponent };
